<template>
  <el-dialog title="邀请他人加入课题协作" :visible.sync="visible" width="420px" append-to-body>
    <div v-loading="!!initLoading">
      <div class="invite-modal">
        <span>通过邀请链接邀请他人加入课题</span>
      </div>
      <div class="invite-input-item">
        <div class="twin-content">
          <el-input class="twin-input" readonly :value="url" />
          <el-button class="twin-btn" type="primary" :disabled="!url" v-copy="url" v-copy:callback="handleCopied">
            <span>复制链接</span>
          </el-button>
        </div>
      </div>
      <div :style="{ marginTop: '20px' }">
        <span>选择协作权限</span>
      </div>
      <el-radio-group v-model="authType" :style="{ marginTop: '12px' }" @change="initInviteUrl">
        <el-radio label="edit">可查看/编辑</el-radio>
        <el-radio label="read">可查看</el-radio>
      </el-radio-group>
    </div>
    <span slot="footer">
      <el-button @click="visible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { services } from '@/service';

export default {
  data() {
    return {
      initLoading: 0,
      authType: 'edit',
      url: ''
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    courseId: {
      type: String,
      required: true
    }
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('update:show', val);
      }
    }
  },
  mounted() {
    this.initInviteUrl();
  },
  methods: {
    async initInviteUrl() {
      try {
        this.initLoading++;

        const { data } = await services.courseware.getInviteLink({
          coursewareId: this.courseId,
          limit: this.authType
        });
        this.url = `${location.origin}${location.pathname}#/invite?id=${data}`;
      } catch (err) {
        this.$error(err);
      } finally {
        this.initLoading--;
      }
    },
    handleCopied(url) {
      if (url) {
        this.$message.success('链接复制成功');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.invite-modal {
  font-size: 14px;
  color: #2c3443;
  line-height: 20px;
  padding: 10px 0;

  .invite-input-item {
    margin-top: 12px;
  }
}
</style>
